import { acceptHMRUpdate, defineStore } from "pinia"
import { ref } from "vue"
import planService from "@/services/plan.service"

const plans = ref(null)
export const useAppStore = defineStore("app", () => {
  const showModalUpgradeToPro = ref(false)
  async function loadPlans(options = { force: false }) {
    if (plans.value && !options.force) {
      return
    }

    try {
      const _plans = await planService.getPlansFull()
      plans.value = [..._plans]
    } catch (error) {
      console.log("Error loadPlans ", error)
    }
  }

  function resetState() {
    plans.value = null
  }

  return { plans, showModalUpgradeToPro, loadPlans, resetState }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot))
}
